import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from '../Button';
import Modal from './BaseModal';
import { Brands } from './../../common/constants';

const ModalTitle = styled.h2`
  ${(props) => ({
    ...props.theme.type.base,
    ...props.theme.type.h1
  })};
  ${(props) => props.theme.type.modalh2};
`;

const ModalBody = styled.div`
  margin: ${(props) => props.theme.whitespace.small} 0;
  ${(props) => props.brand === Brands.Wireless ? props.theme.type.modal : props.theme.type.base};
  font-family: ${(props) => props.theme.type.modal.fontFamily};
  text-align: center;
`;

const ModalNotice = styled.div`
  text-align: center;
  margin-top: 20px;
  font-size: 11px;
  line-height: 15px;
  color: #696969;
  margin: ${(props) => props.theme.whitespace.large} 0 ${(props) => props.theme.whitespace.large} 0;
`;

const ConfirmModalWireless = ({
  brand,
  title,
  text,
  notice,
  confirmLabel,
  cancelLabel,
  onConfirm,
  ...props
}) => (
  <ConfirmModalContainerWireless className={brand} {...props}>
    <ModalTitle className="title">{title}</ModalTitle>
    <ModalBody brand={brand} className="body" dangerouslySetInnerHTML={{__html: text}} />
    <CancelButtonWireless block onClick={props.onClose}>
      {cancelLabel}
    </CancelButtonWireless>
    <ConfirmButtonWireless
      block
      onClick={() => {
        onConfirm();
        props.onClose();
      }}
    >
      {confirmLabel}
    </ConfirmButtonWireless>
    <ModalNotice className="notice">{notice}</ModalNotice>
  </ConfirmModalContainerWireless>
);
ConfirmModalWireless.propTypes = {
  brand: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  notice: PropTypes.string,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

const ConfirmModalRegular = ({
  brand,
  title,
  text,
  notice,
  confirmLabel,
  cancelLabel,
  onConfirm,
  ...props
}) => (
  <Modal className={brand} {...props}>
    <ModalTitle className="title">{title}</ModalTitle>
    <ModalBody className="body" dangerouslySetInnerHTML={{__html: text}} />
    <Button
      block
      onClick={() => {
        onConfirm();
        props.onClose();
      }}
    >
      {confirmLabel}
    </Button>
    <ModalNotice className="notice">{notice}</ModalNotice>
    <Button block onClick={props.onClose}>
      {cancelLabel}
    </Button>
  </Modal>
);
ConfirmModalRegular.propTypes = {
  brand: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  notice: PropTypes.string,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

const ConfirmModal = ({
  ...props
}) => {
  if (props.brand === Brands.Wireless) {
    return ConfirmModalWireless(props);
  }

  return ConfirmModalRegular(props);
};

const ConfirmButtonWireless = styled.button`
  ${(props) => props.theme.type.confirmButton};
  &:hover {
    color: ${(props) => props.theme.colours.hover}};
  }
`;

const CancelButtonWireless = styled.button`
  ${(props) => props.theme.type.cancelButton};
  &:hover {
    background: ${(props) => props.theme.colours.hover}};
    cursor: pointer;
  }
`;

const ConfirmModalContainerWireless = styled(Modal)`
  .Modal {
    ${(props) => props.theme.type.confirmModal};
    @media (max-width: 400px) {
      max-width: 91vw;
    }
  }
`;

ConfirmModal.propTypes = {
  brand: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  notice: PropTypes.string,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

ConfirmModal.defaultProps = {
  title: 'Are you sure?',
  text: null,
  notice: null,
  confirmLabel: 'Yes',
  cancelLabel: 'No'
};

export default ConfirmModal;
